import { render } from "./IndexForm.vue?vue&type=template&id=7b9771fe&ts=true"
import script from "./IndexForm.vue?vue&type=script&lang=ts"
export * from "./IndexForm.vue?vue&type=script&lang=ts"

import "./IndexForm.vue?vue&type=style&index=0&id=7b9771fe&lang=css"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__